<!-- 内层铜厚 -->
<template>
  <BaseFormItem
    :label="fields.label"
    :labelTips="fields.labelTips"
  >
    <BaseRadioGroup v-model="val" @change="handleEmit">
      <el-radio-button
        v-for="item in fields.options"
        :key="item.value"
        :label="item.value"
        :disabled="item.disabled"
      >{{ item.label }}</el-radio-button>
    </BaseRadioGroup>
  </BaseFormItem>
</template>

<script>
import { getROGERSFields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: [String, Number],
      default: 1
    }
  },
  data() {
    return {
      val: +this.value
    }
  },
  computed: {
    fields() {
      return getROGERSFields('insidecopper')
    }
  },
  watch: {
    value(newVal) {
      this.val = +newVal
    }
  },
  mounted() {
    if (this.value == 0) {
      this.val = 1
      this.handleEmit()
    }
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>